import AnimationMixin from '../mixins/AnimationMixin'
import GetComputedStyles from '../mixins/GetComputedStyles'
import GettersHelper from '../mixins/GettersHelper'
import ComputedProperties from '../mixins/ComputedProperties'

export default {
  install (Vue) {
    Vue.use(AnimationMixin)
    Vue.use(GetComputedStyles)
    Vue.use(GettersHelper)
    Vue.use(ComputedProperties)
  }
}
